// client/src/components/auth/RequireAdmin.js
import { Navigate } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'

function RequireAdmin({ children }) {
  const { loading, isLoggedIn, isAdmin } = useAuth()

  if (loading) return <p>Loading...</p>
  if (!isLoggedIn) return <Navigate to="/landing" replace />
  if (!isAdmin) return <Navigate to="/" replace />

  return children
}

export default RequireAdmin
